import React from 'react';
import classnames from 'classnames/bind';


import styles from './ProductCardBase.module.scss';
import { Skeleton } from 'gd-design-library';

const CN = 'product-card-base';
const actionAreaClassName = `${CN}--action-area`;
const contentClassName = `${actionAreaClassName}--content`;
const titleClassName = `${contentClassName}--title`;
const cx = classnames.bind(styles);

export const ProductCardBaseSkeleton: React.FC = () => (
  <div className={ cx(CN) }>
    <div className={ cx(actionAreaClassName) }>
      <Skeleton height='120px' />
      <div className={ cx(contentClassName) }>
        <Skeleton
          width='120px'
          className={ cx(titleClassName) }
        />
        <Skeleton width='50px' />
      </div>
    </div>
  </div>
);
